<ion-content>
  <div class="setup-content">
    <!-- Back Button -->
    <ion-button
      fill="clear"
      class="back-button"
      (click)="goBack()">
      <ion-icon name="arrow-back" slot="icon-only"></ion-icon>
    </ion-button>

    <!-- Main Question -->
    <h1 class="setup-question">
      {{ 'AUDIO_SETUP.CUSTOMIZE_AUDIO' | translate }}
    </h1>

    <!-- Audio Speed Section -->
    <div class="preference-section">
      <h2 class="preference-title">{{ 'AUDIO_SETUP.PLAYBACK_SPEED' | translate }}</h2>
      <ion-segment
        [(ngModel)]="audioSpeed"
        (ionChange)="onAudioSpeedChange()"
        mode="ios"
        class="speed-segment">
        <ion-segment-button [value]="1" class="speed-option">
          <ion-icon name="play-skip-back" slot="start"></ion-icon>
          <ion-label>{{ 'AUDIO_SETUP.SLOW' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button [value]="2" class="speed-option">
          <ion-icon name="play" slot="start"></ion-icon>
          <ion-label>{{ 'AUDIO_SETUP.MEDIUM' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button [value]="3" class="speed-option">
          <ion-icon name="play-skip-forward" slot="start"></ion-icon>
          <ion-label>{{ 'AUDIO_SETUP.FAST' | translate }}</ion-label>
        </ion-segment-button>
      </ion-segment>
      <div class="speed-description">
        <p class="description-text">
          {{ 'AUDIO_SETUP.CURRENT_SPEED' | translate }}: {{ getSpeedLabel(audioSpeed) }}
        </p>
      </div>
    </div>

    <!-- Voice Gender Section -->
    <div class="preference-section">
      <h2 class="preference-title">{{ 'AUDIO_SETUP.VOICE_TYPE' | translate }}</h2>
      <ion-segment
        [(ngModel)]="femaleVoice"
        (ionChange)="onVoiceGenderChange()"
        mode="ios"
        class="voice-segment">
        <ion-segment-button
          [value]="true"
          class="voice-option">
          <ion-icon name="female" slot="start"></ion-icon>
          <ion-label>{{ 'AUDIO_SETUP.FEMALE_VOICE' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button
          [value]="false"
          class="voice-option">
          <ion-icon name="male" slot="start"></ion-icon>
          <ion-label>{{ 'AUDIO_SETUP.MALE_VOICE' | translate }}</ion-label>
        </ion-segment-button>
      </ion-segment>
      <div class="voice-description">
        <p class="description-text">
          {{ 'AUDIO_SETUP.SELECTED_VOICE' | translate }}: {{ femaleVoice ? ('AUDIO_SETUP.FEMALE_VOICE' | translate) : ('AUDIO_SETUP.MALE_VOICE' | translate) }}
        </p>
      </div>
    </div>

    <!-- Save Button -->
    <ion-button
      expand="block"
      color="success"
      class="continue-button"
      (click)="savePreferences()">
      {{ getButtonText() }}
      <ion-icon name="checkmark" slot="end"></ion-icon>
    </ion-button>
  </div>
</ion-content>
